import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { contactInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-900 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-bold text-white mb-2">
              MEDUSAI <span className="text-purple-400">GRAPHICS</span>
            </h3>
            <p className="text-gray-400 mb-4">Custom Wall Murals. Bold Graphics. Zero Limits.</p>
            <div className="flex gap-2">
              <div className="w-12 h-1 bg-purple-600 rounded"></div>
              <div className="w-8 h-1 bg-purple-400 rounded"></div>
              <div className="w-4 h-1 bg-purple-300 rounded"></div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-400 hover:text-purple-400 transition-colors">Services</a>
              </li>
              <li>
                <a href="#gallery" className="text-gray-400 hover:text-purple-400 transition-colors">Gallery</a>
              </li>
              <li>
                <a href="#how-it-works" className="text-gray-400 hover:text-purple-400 transition-colors">How It Works</a>
              </li>
              <li>
                <a href="#pricing" className="text-gray-400 hover:text-purple-400 transition-colors">Pricing</a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-purple-400 transition-colors">Contact</a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Contact</h4>
            <div className="space-y-3">
              <a href={`mailto:${contactInfo.emailAlt}`} className="flex items-center gap-2 text-gray-400 hover:text-purple-400 transition-colors">
                <Mail className="w-4 h-4" />
                <span className="break-all">{contactInfo.emailAlt}</span>
              </a>
              <div className="flex items-center gap-2 text-gray-400">
                <MapPin className="w-4 h-4" />
                <span>{contactInfo.location}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-900 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} Medusai Graphics Unlimited. All rights reserved.
          </p>
          <p className="text-gray-500 text-sm">
            Transforming walls into art since 2025
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
